module.exports = __webpack_public_path__ + "22cc19102dc837bf3aa19a12cdb9728b.png";